import React from 'react';
import { RelsTypes } from 'domain/hooks/api/api';
import { AuthorizationService } from 'domain/services';
import { isValid } from 'domain/utils';
import { EditAlert } from 'pages/alerts/edit/EditAlert';

import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';

import { RootPage } from 'pages/root/RootPage';
import LoginPage from 'pages/auth/LoginPage';
import ResetPage from 'pages/auth/ResetPage';
import { CardListPage } from 'pages/base/CardList';
import { SchemaEdit } from 'pages/schemas/SchemaEdit';
import { RedirectComponent } from 'pages/base/RedirectComponent';

export enum AppRoutes {
	Home = '/',
	Panel = '/panel',
	Dashboard = '/dashboard',
	VirtualStations = '/virtual-stations',
	Alerts = '/alert-definitions',
	Derived = '/derived',
	SchemaEditor = '/edit/:id',
	Stations = '/stations',
	Users = '/users',
	Crops = '/crops',
	AdminAlerts = '/admin-alerts',
	Login = '/admin/login',
	Logout = '/admin/logout',
	EditAlert = '/edit/alert-definitions?id=:id',
	EditCrop = '/edit/crops?id=:id',
	EditDerived = '/edit/derived?id=:id',
	EditFarm = '/edit/farms?id=:id',
	EditUser = '/edit/users?id=:id',
	EditStation = '/edit/stations?id=:id',
	EditVirtualStation = '/edit/virtual-stations?id=:id',
}

const mainRoutes: (RouteObject & { rel: RelsTypes })[] = [
	{
		rel: 'panel',
		path: AppRoutes.Panel,
	},
	{
		rel: 'dashboards',
		path: AppRoutes.Dashboard,
	},
	{
		rel: 'alerts',
		path: AppRoutes.Alerts,
	},
	{
		rel: 'derived',
		path: AppRoutes.Derived,
	},
	{
		rel: 'stations',
		path: AppRoutes.Stations,
	},
	{
		rel: 'users',
		path: AppRoutes.Users,
	},
	{
		rel: 'crops',
		path: AppRoutes.Crops,
	},
	{
		rel: 'adminAlerts',
		path: AppRoutes.AdminAlerts,
	},
];

export const router = createBrowserRouter([
	{
		path: AppRoutes.Home,
		element: (
			<RedirectComponent from={[AppRoutes.Home]} to={AppRoutes.Panel}>
				<RootPage />
			</RedirectComponent>
		),
		loader: async () => {
			const token = AuthorizationService.safeGetAuthorization();
			if (token && isValid(token)) {
				return Promise.resolve(AppRoutes.Home);
			}
			return Promise.resolve(AppRoutes.Login);
		},
		children: [
			...mainRoutes.map((route) => ({
				path: route.path,
				element: <CardListPage rel={route.rel} />,
			})),
			{
				path: AppRoutes.EditAlert,
				element: <EditAlert />,
			},
			{
				path: AppRoutes.SchemaEditor,
				element: <SchemaEdit />,
			},
		],
	},
	{
		path: '/admin/logout',
		element: <LoginPage logout />,
	},
	{
		path: '/login',
		element: <LoginPage />,
	},
	{
		path: '/password-reset',
		element: <ResetPage />,
	},
	{
		path: '*',
		element: <Navigate to={'/'} />,
	},
]);
